// src/pages/CommunityGuidelines.jsx
import React from "react";

export default function CommunityGuidelines() {
  const updatedAt = "16 janvier 2026";
  const companyName = "GoShop";
  const contactEmail = "goshop@gmail.com"; // ✅ mets ton vrai email

  return (
    <div style={{ background: "#0b1226", minHeight: "100vh", padding: "24px 12px" }}>
      <div
        style={{
          maxWidth: 980,
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: 18,
          padding: "22px 18px",
          boxShadow: "0 18px 45px rgba(0,0,0,.18)",
        }}
      >
        <header style={{ marginBottom: 14 }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, color: "#0f172a" }}>
            Charte de la communauté {companyName}
          </h1>
          <p style={{ margin: "6px 0 0", color: "#64748b", fontSize: 13 }}>
            Dernière mise à jour : <strong>{updatedAt}</strong>
          </p>
        </header>

        <section style={{ color: "#111827", lineHeight: 1.65, fontSize: 14 }}>
          <p>
            Cette charte vise à garantir une expérience sûre et respectueuse pour les clients et vendeurs.
            Elle s’applique à tous : publications, messages, fiches produits, commentaires, échanges.
          </p>

          <h2 style={h2}>1) Respect et sécurité</h2>
          <ul style={ul}>
            <li>Pas d’insultes, menaces, harcèlement, discriminations ou propos haineux.</li>
            <li>Pas de contenus choquants (violence, pornographie, exploitation, etc.).</li>
            <li>Pas d’arnaques, de manipulation ou de pressions abusives.</li>
          </ul>

          <h2 style={h2}>2) Transparence des vendeurs</h2>
          <ul style={ul}>
            <li>Décrire correctement le produit (marque, taille, état, contenu, compatibilité).</li>
            <li>Afficher un prix réel (pas de prix “piège” ou fausses promotions).</li>
            <li>Utiliser des images représentatives (pas d’images trompeuses ou volées si interdites).</li>
          </ul>

          <h2 style={h2}>3) Produits interdits</h2>
          <ul style={ul}>
            <li>Contrefaçons, produits volés, illégaux ou non autorisés.</li>
            <li>Produits dangereux ou réglementés sans autorisation.</li>
            <li>Tout contenu incitant à la haine, à la violence, ou à des activités illégales.</li>
          </ul>

          <h2 style={h2}>4) Spam et abus</h2>
          <ul style={ul}>
            <li>Pas de spam (répétitions, pubs agressives, messages non sollicités).</li>
            <li>Pas d’utilisation abusive des coordonnées clients.</li>
            <li>Pas de tentatives de contournement du système de validation.</li>
          </ul>

          <h2 style={h2}>5) Sanctions possibles</h2>
          <ul style={ul}>
            <li>Suppression de contenu / produit.</li>
            <li>Produit remis en “pending” pour revue.</li>
            <li>Suspension temporaire ou définitive du compte vendeur.</li>
            <li>Signalement aux autorités si nécessaire (fraude / illégalité).</li>
          </ul>

          <h2 style={h2}>6) Signaler un contenu</h2>
          <p>
            Pour signaler un produit, un vendeur ou un comportement abusif, contactez-nous :{" "}
            <a href={`mailto:${contactEmail}`} style={link}>
              {contactEmail}
            </a>
          </p>

          <p style={{ marginTop: 10 }}>
            En utilisant {companyName}, vous acceptez également :{" "}
            <a href="/terms" style={link}>CGU</a>{" "}
            et{" "}
            <a href="/privacy" style={link}>Politique de confidentialité</a>.
          </p>

          <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "18px 0" }} />
          <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>
            © {new Date().getFullYear()} {companyName}. Tous droits réservés.
          </p>
        </section>
      </div>
    </div>
  );
}

const h2 = {
  marginTop: 16,
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
};

const ul = {
  marginTop: 6,
  marginBottom: 10,
  paddingLeft: 18,
};

const link = { color: "#1e40af", fontWeight: 800, textDecoration: "none" };
